import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchPrepayments } from '../../../../actions/prepayment/prepaymentList'
import Prepayments from '../../Prepayments'
import { AppState } from '../../../../reducers'
import { FiltersBar, Filters } from '../../../Utils/Filters/Filter'
import { FilterFromDate, FilterToDate, FilterClientName, FilterTel, FilterStatusPrepayment, FilterText } from '../../../Utils/Filters'
import { PrepaymentListState } from '../../../../reducers/prepayment/prepaymentList'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { SessionState, isAdmin, isHeadSales, isManager, isStaff } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { Stack } from '@mui/material'
import { PreorderListState } from '../../../../reducers/preorder/preorderList'
import { PreorderDataState } from '../../../../reducers/preorder/preorderData'
import { fetchPendingPreorder } from '../../../../actions/preorder/preorder'
import { fetchPreorders } from '../../../../actions/preorder/preorderList'

interface Props {
  fullInfo?: boolean
  prepaymentList: PrepaymentListState
  preorderList: PreorderListState
  preorder: PreorderDataState
  session: SessionState
}

const PrepaymentList: React.FC<Props> = ({ prepaymentList, preorder, preorderList, session, fullInfo = true } ) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['prepayment','client'])


  useEffect(() => {
    dispatch(fetchPendingPreorder())
    dispatch(fetchPreorders())
  }, [dispatch])
  

  useEffect(() => {
    dispatch(fetchPrepayments(!fullInfo ? '?status=ACTIVO' : history.location.search))
  }, [dispatch, history.location.search, fullInfo])

  const initDefaultFilters : Filters = {
    from: moment().startOf('month').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    to: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    status: 'ACTIVO'
  }

  const linkToPrepaymentDetail = (prepaymentId: string) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/prepayments/detail/${prepaymentId}`
    history.push(detailUrl)
  }

  
  const constructRows = () => {
    const rows = (prepaymentList.prepayments || []).filter((pp) =>  pp.fecha >= '2024-06-18' && 
       preorderList.preorders?.every((po) => (po.status !== 'A' && po.status !== 'P' && po.status !== 'H' && po.status !== 'C') || po.prepaymentId !== pp.id_acopio) ).map(s => ({ data: s }))
    const inUseA = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'A') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'A', user: '', data: s }));

    const inUseP = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'P') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'P', user: '', data: s }));

    const inUseC = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'C') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'C', user: '', data: s }));

    const inUseH = (prepaymentList.prepayments || []).filter((pp) => 
      preorderList.preorders?.some((po) => (po.status === 'H') && po.prepaymentId === pp.id_acopio )).map(s => ({ action: "disabled", statusPO: 'H', user: '', data: s }));

    const inUseN = (prepaymentList.prepayments || []).filter((pp) => pp.fecha < '2024-06-18').map(s => ({ action: "disabled", statusPO: 'N', user: '', data: s }));

    inUseA.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseP.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseC.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseH.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );
    inUseN.every( s => s.user = preorderList.preorders?.find( p => s.data.id_acopio === p.prepaymentId )?.owner?.fullName ?? '' );

    return rows.concat(inUseA).concat(inUseP).concat(inUseH).concat(inUseC).concat(inUseN).sort((a, b) => a.data.fecha > b.data.fecha ? -1 : a.data.fecha < b.data.fecha ? 1 : 0 );
  }
  

  return (
    <Stack style={{ height: fullInfo ? 'calc(100% - var(--header-height)': ''}}>
      { fullInfo &&
        <FiltersBar defaultFilters={initDefaultFilters}>
          <FilterFromDate name="from"  label={t("fromDate")} />
          <FilterToDate name="to" label={t("toDate")} />
          <FilterTel name="prepaymentNumber" label={t("number")} />
          <FilterText name="description"  label={t("denomination")} controlledLength={3}/>
          <FilterStatusPrepayment name="status" label={t("status")} />
          {(isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? <FilterClientName name="codigo_cliente" label={t('title', { ns: 'client'})}/> : <></>}
        </FiltersBar>}
      <Prepayments
        rows={!fullInfo ? (prepaymentList.prepayments || []).map(s => ({ data: s })) : constructRows()}
        //rows={(prepaymentList.prepayments || []).map(s => ({ data: s }))}
        loading={prepaymentList.isFetching}
        fullInfo={fullInfo}
        pagination={prepaymentList.pagination || undefined}
        onClickDetail={linkToPrepaymentDetail}
      />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  prepaymentList: state.prepaymentList,
  preorder: state.preorderData,
  preorderList: state.preorderList,
  session: state.session
})

export default connect(mapStateToProps, null)(PrepaymentList)